<template>

  <pie-chart v-if="chart" :data="chart.data"
   :donut="true"
   :legend="showLegend ? posLegend : null"
   :colors="chart.colors">
   </pie-chart>


</template>

<script>

import ChartMixins from '@/mixins/ChartMixins'

export default {

  mixins: [ChartMixins],

  props: {

    stats: {
      type: Object,
      default: null
    },

    showLegend: {
      type: Boolean,
      default: true
    },

    posLegend: {
      type: String,
      default: 'right'
    }
  },

  data () {

    return {
      chart: null,
      st: (this.stats ? this.stats : this.getStats())
    }

  },


  created () {
    this.chart = this.preparePieChart([
      ['Active Sites (' + this.st.sitesActive + ')', this.st.sitesActive],
      ['Dismantled Sites(' + this.st.sitesDismantled + ')', this.st.sitesDismantled],
      ['Temporary Sites(' + this.st.sitesTemporary + ')', this.st.sitesTemporary],
      ['New Sites (' + this.st.sitesNew + ')', this.st.sitesNew],
      ['Exclusive Sites (' + this.st.sitesExclusive + ')', this.st.sitesExclusive],
      ['Candidate Sites (' + this.st.sitesCandidate + ')', this.st.sitesCandidate],
      ['Land Only Sites (' + this.st.sitesLandOnly + ')', this.st.sitesLandOnly]
    ],
    ['#409EFF', '#F56C6C', '#909399', '#67C23A', '#303133', '#E6A23C', '#C0C4CC'])

  }

}

</script>



// WEBPACK FOOTER //
// SitesChart.vue?7c16f22e